import React from 'react';
import styles from './styles.module.scss';

interface SlideHeaderProps {
  savingsSubText: string;
  savingsText: string;
  zipCode?: string;
  totalSavings?: string;
}

/**
 * Header delle slide con benefici e CAP badge
 */
const SlideHeader: React.FC<SlideHeaderProps> = ({
  savingsSubText,
  savingsText,
  zipCode,
  totalSavings,
}) => {
  return (
    <div className={styles.slideHeader}>
      {/* CAP Badge */}
      {zipCode && (
        <div className={styles.capBadge}>
          CAP {zipCode}
        </div>
      )}

      <div className={styles.savingsSubText}>{savingsSubText}</div>

      <div className={styles.savingsMain}>
        <div className={styles.savingsText}>{savingsText}</div>
      </div>

      {totalSavings && (
        <div className={styles.savingsIndicator}>
          <span>Risparmio totale: </span>
          <strong>{totalSavings}</strong>
        </div>
      )}
    </div>
  );
};

export default SlideHeader;
